import { createContext } from "react";

export const InsideDialogContext = createContext(false);
